// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoReportModal-cls1_KAU","cls2":"VideoReportModal-cls2_0gl VideoReportModal-cls1_KAU"};